import { UserLoginStatusType } from "./../../types/user";
import { State } from "./../../types/redux";

export const getUserAuthStatus = (state: State): UserLoginStatusType =>
  state.user.userLoginStatus;

export const getUserError = (state: State): string => state.user.error;

export const getUserRole = (state: State) => state.user.role;
